import React from 'react';

const DocumentFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="document-fill_svg__a"
                d="M0 0h11v5h5v15H0V0zm12 1l3 3h-3V1zm-8 9h8v1H4v-1zm0-3h8v1H4V7zm0 6h8v1H4v-1z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(4 2)">
            <mask id="document-fill_svg__b" fill="#fff">
                <use xlinkHref="#document-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#document-fill_svg__a" />
            <g mask="url(#document-fill_svg__b)">
                <path fill="#000" d="M-4-2h24v24H-4z" />
            </g>
        </g>
    </svg>
);

DocumentFillSvg.displayName = 'DocumentFillSvg';
export default DocumentFillSvg;
